import axios from 'axios';
import { HOST_API } from '../api/config';
import AdminSecureStorage from './adminSecureStorage';
import SecureStorage from './secureStorage';
import { PATHS } from '../routes/routes';
// -----------------------------------
const axiosInstance = axios.create({
    baseURL: HOST_API
});

axiosInstance.interceptors.request.use((req) => {
    if (process.env.NODE_ENV !== 'production') {
    }
    
    // Add admin token to requests if available and if it's an admin route
    if (req.url?.startsWith('/admin/')) {
        const adminToken = AdminSecureStorage.getAdminToken();
        if (adminToken) {
            req.headers.Authorization = `Bearer ${adminToken}`;
        }
    }
    
    // Add customer token to public customer routes when available
    if (req.url?.startsWith('/public/') && !req.url?.startsWith('/public/admin/')) {
        const customerToken = SecureStorage.getCustomerToken();
        if (customerToken) {
            req.headers.Authorization = customerToken;
        }
    }
    
    return req;
});
axiosInstance.interceptors.response.use(
    (res) => {
        if (process.env.NODE_ENV !== 'production') {
        }

        return res;
    },
    (error) => {
        if (process.env.NODE_ENV !== 'production') {
        }
        const status = error?.response?.status;
        const url: string | undefined = error?.config?.url;
        if (status === 401) {
            // Do not clear customer session or redirect for public games endpoints
            if (url?.startsWith('/public/games')) {
                return Promise.reject(error);
            }
            // Determine context by url
            const isAdmin = url?.startsWith('/admin/');
            if (isAdmin) {
                AdminSecureStorage.removeAdminToken?.();
                window.location.href = PATHS.ADMIN_LOGIN;
            } else {
                SecureStorage.removeCustomerToken?.();
                window.location.href = PATHS.CUSTOMER_SIGNIN;
            }
        }
        return Promise.reject(error);
    }
);
export { axiosInstance };
